const colorConfiguration = {
  // primaryColor: '#357a38',
  // secondaryColor: '#ff9100'
}

export default colorConfiguration
